// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';
import { Profile } from 'src/constants/DefaultValues';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <MAvatar
      src={user.avatar || Profile}
      alt={user.user_name}
      color={user.photoURL ? 'default' : createAvatar(user.user_name).color}
      {...other}
    >
      {createAvatar(user.user_name).name}
    </MAvatar>
  );
}
